import React, { useEffect, createElement } from 'react';
import { Play, User, Eye, AlertTriangle, Check, X, ChevronRight, Menu, Star } from 'lucide-react';
export function App() {
  // Initialize Meta Pixel
  useEffect(() => {
    // Meta Pixel Code
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script tags exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    window.fbq('init', '1604022217679763');
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white text-[#1a1a1a] antialiased selection:bg-[#d4a5a5] selection:text-white" data-id="element-0">
      <style data-id="element-1">{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400&display=swap');
        
        .font-serif { font-family: 'Playfair Display', serif; }
        .font-sans { font-family: 'Inter', sans-serif; }
        
        .drop-cap::first-letter {
          float: left;
          font-size: 3.5rem;
          line-height: 0.8;
          font-weight: 700;
          margin-right: 0.5rem;
          margin-top: 0.2rem;
          font-family: 'Playfair Display', serif;
          color: #d4a5a5;
        }
      `}</style>

      {/* Navigation Header */}
      <header className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white/95 backdrop-blur-sm" data-id="element-2">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-4 sm:px-6" data-id="element-3">
          <div className="flex items-center gap-4" data-id="element-4">
            <button className="p-1 text-gray-600 hover:text-black md:hidden" data-id="element-5">
              <Menu className="h-6 w-6" data-id="element-6" />
            </button>
            <span className="font-serif text-2xl font-bold tracking-tight text-black" data-id="element-7">
              Salud Vital
            </span>
            <a href="https://angelitasgummy.com/products/angelitas" target="_blank" rel="noopener noreferrer" className="rounded bg-[#c08b9e] px-4 py-2 text-sm font-bold uppercase tracking-wide text-white transition-colors hover:bg-[#b07a8e]" data-id="element-8">
              VER ANGELITAS
            </a>
          </div>
          <a href="https://angelitasgummy.com/products/angelitas" target="_blank" rel="noopener noreferrer" className="hidden rounded-full bg-[#d4a5a5] px-6 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#c08b8b] sm:block" data-id="element-9">
            Ver Disponibilidad
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6 sm:py-12" data-id="element-10">
        {/* Breadcrumb */}
        <nav className="mb-6 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-11">
          <span data-id="element-12">México</span>
          <ChevronRight className="h-3 w-3" data-id="element-13" />
          <span className="text-[#d4a5a5]" data-id="element-14">Salud de la Mujer</span>
        </nav>

        {/* Headline */}
        <h1 className="mb-6 font-serif text-3xl font-bold leading-tight text-gray-900 sm:text-4xl md:text-5xl lg:leading-[1.1]" data-id="element-15">
          ALERTA: Si despiertas cansada aunque duermas 8 horas, tu sangre podría
          estar "muriendo" en silencio
        </h1>

        {/* Author Byline */}
        <div className="mb-10 flex items-center justify-between border-y border-gray-100 py-4" data-id="element-16">
          <div className="flex items-center gap-3" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/wcNyUvYova39p52LCnv9zc/Captura_de_pantalla_2026-01-24_a_las_12.17.15.png" alt="Carolina Mendez" className="h-12 w-12 rounded-full object-cover" data-id="element-18" />
            <div data-id="element-19">
              <div className="text-sm font-bold text-gray-900" data-id="element-20">
                Por Carolina Mendez
              </div>
              <div className="text-xs text-gray-500" data-id="element-21">Reportera de Salud</div>
            </div>
          </div>
          <div className="hidden text-right text-xs text-gray-500 sm:block" data-id="element-22">
            <div data-id="element-23">Enero 2025</div>
            <div className="flex items-center justify-end gap-1 text-[#d4a5a5]" data-id="element-24">
              <Eye className="h-3 w-3" data-id="element-25" />
              <span data-id="element-26">247,892 lecturas</span>
            </div>
          </div>
        </div>

        {/* Article Body */}
        <article className="font-sans text-lg leading-relaxed text-gray-800" data-id="element-27">
          <p className="drop-cap mb-6" data-id="element-28">
            Son las 6:30 de la mañana. El despertador suena y tú ya estás
            agotada.
          </p>

          <p className="mb-6" data-id="element-29">
            Dormiste 7, 8, hasta 9 horas... pero sientes que no descansaste ni
            una. Te levantas arrastrando el cuerpo. Te preparas un café —el
            primero de muchos— y apenas te hace efecto.
          </p>

          <p className="mb-6" data-id="element-30">
            Para las 3 de la tarde, tu cuerpo se "apaga". La niebla mental te
            invade. Las palabras se te olvidan a medio camino. Y tus piernas...
            tus piernas pesan como si cargaras piedras.
          </p>

          <p className="mb-8 font-bold italic text-gray-900" data-id="element-31">
            ¿Te suena familiar?
          </p>

          <p className="mb-6" data-id="element-32">
            Si eres mujer y pasaste de los 40, probablemente esto es tu día a
            día. Y lo peor es que seguramente piensas que es "normal a tu edad".
          </p>

          <p className="mb-10 text-2xl font-serif font-bold text-center text-[#d4a5a5]" data-id="element-33">
            No lo es.
          </p>

          <h2 className="mb-6 font-serif text-2xl font-bold text-gray-900" data-id="element-34">
            El 65% de las mujeres mexicanas viven así — sin saber por qué
          </h2>

          <p className="mb-6" data-id="element-35">
            Según datos recientes, más de 6 millones de mujeres mexicanas
            mayores de 40 años viven con este agotamiento crónico. Despiertan
            cansadas. Pasan el día exhaustas. Se acuestan destruidas.
          </p>

          <p className="mb-6" data-id="element-36">
            Y el ciclo se repite. Seguramente ya intentaste de todo:
          </p>

          <div className="mb-10 space-y-4 rounded-xl bg-gray-50 p-6 sm:p-8" data-id="element-37">
            <ul className="space-y-4" data-id="element-38">
              {[{
              title: 'Más café',
              desc: 'Solo te pone nerviosa y con el corazón acelerado'
            }, {
              title: 'Vitaminas y suplementos genéricos',
              desc: 'Llevas meses tomándolos y nada cambia'
            }, {
              title: 'Dormir más temprano',
              desc: 'Despiertas igual de agotada'
            }, {
              title: 'Ir al IMSS',
              desc: 'Horas de espera para que te digan "todo está normal, es la edad"'
            }, {
              title: 'Descansar más',
              desc: 'Imposible cuando eres el pilar de tu familia'
            }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-39">
                  <div className="mt-1 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-40">
                    <X className="h-3 w-3" data-id="element-41" />
                  </div>
                  <span data-id="element-42">
                    <span className="font-bold text-gray-900" data-id="element-43">
                      {item.title}
                    </span>{' '}
                    <span className="text-gray-400" data-id="element-44">→</span> {item.desc}
                  </span>
                </li>)}
            </ul>
          </div>

          <p className="mb-10" data-id="element-45">
            Aquí está la verdad incómoda: ninguna de estas "soluciones" funciona
            porque{' '}
            <span className="font-bold bg-[#d4a5a5]/20 px-1" data-id="element-46">
              NO atacan el verdadero problema.
            </span>
          </p>

          <h2 className="mb-6 font-serif text-2xl font-bold text-gray-900" data-id="element-47">
            Lo que científicos del Premio Nobel descubrieron (y tu médico nunca
            te dijo)
          </h2>

          <p className="mb-6" data-id="element-48">
            En 1998, tres científicos ganaron el Premio Nobel de Medicina por un
            descubrimiento impactante.
          </p>

          <p className="mb-6" data-id="element-49">
            Encontraron que existe una molécula en tu cuerpo llamada{' '}
            <strong className="text-[#d4a5a5]" data-id="element-50">ÓXIDO NÍTRICO</strong> que
            controla prácticamente TODO tu sistema circulatorio.
          </p>

          <p className="mb-6" data-id="element-51">
            Esta molécula es como el "sistema de comunicación" de tu sangre. Le
            dice a tus arterias cuándo abrirse, cuándo relajarse, y cuánta
            sangre dejar pasar.
          </p>

          <div className="my-8 border-l-4 border-[#d4a5a5] bg-gray-50 p-6 italic text-gray-700" data-id="element-52">
            <strong data-id="element-53">El problema es este:</strong> Después de los 40 años —y
            especialmente durante la menopausia— tu cuerpo pierde hasta el 50%
            de su capacidad de producir esta molécula vital.
          </div>

          <p className="mb-6" data-id="element-54">
            Sin suficiente óxido nítrico, tus arterias se "quedan en silencio".
            La sangre fluye lenta. El oxígeno no llega bien a tus músculos ni a
            tu cerebro.
          </p>

          <p className="mb-6 font-bold" data-id="element-55">El resultado:</p>

          <div className="mb-10 grid gap-4 sm:grid-cols-2" data-id="element-56">
            {[{
            title: 'Sin oxígeno suficiente',
            desc: 'Fatiga constante (aunque duermas bien)'
          }, {
            title: 'Sangre circulando lenta',
            desc: 'Piernas pesadas como plomo'
          }, {
            title: 'Cerebro sin nutrientes',
            desc: 'Niebla mental, olvidos, falta de concentración'
          }, {
            title: 'Corazón trabajando de más',
            desc: 'Agotamiento incluso en reposo'
          }].map((item, i) => <div key={i} className="rounded-lg border border-gray-100 p-4 shadow-sm" data-id="element-57">
                <div className="mb-2 flex items-center gap-2 text-[#d4a5a5]" data-id="element-58">
                  <Check className="h-5 w-5" data-id="element-59" />
                  <span className="font-bold text-gray-900" data-id="element-60">{item.title}</span>
                </div>
                <p className="text-sm text-gray-600" data-id="element-61">{item.desc}</p>
              </div>)}
          </div>

          <p className="mb-10 text-center text-xl font-medium" data-id="element-62">
            En otras palabras: tu sangre está "muriendo de hambre" — y tú
            sientes ese agotamiento en cada célula de tu cuerpo.
          </p>

          <h2 className="mb-6 font-serif text-2xl font-bold text-gray-900" data-id="element-63">
            ¿Por qué nadie te había dicho esto?
          </h2>

          <p className="mb-6" data-id="element-64">
            Buena pregunta. El sistema de salud está diseñado para atender
            CRISIS, no para PREVENIR. Tu médico espera a que algo se rompa para
            actuar. Las vitaminas genéricas no atacan este problema específico.
            Y la industria farmacéutica prefiere venderte soluciones temporales
            que tengas que comprar una y otra vez.
          </p>

          <p className="mb-6" data-id="element-65">
            Pero aquí está lo curioso...{' '}
            <strong data-id="element-66">Nuestras abuelas ya lo sabían.</strong>
          </p>

          <p className="mb-6" data-id="element-67">
            En México, las antiguas "boticas" hablaban de "refrescar la sangre"
            con alimentos rojos. Sabían que ciertos vegetales de color rojo
            intenso podían devolver la vitalidad.
          </p>

          <p className="mb-10 font-medium" data-id="element-68">
            La ciencia moderna finalmente les dio la razón.
          </p>

          <h2 className="mb-6 font-serif text-2xl font-bold text-gray-900" data-id="element-69">
            La solución que está cambiando la vida de miles de mexicanas
          </h2>

          <p className="mb-6" data-id="element-70">
            Investigadores descubrieron que existe una forma de restaurar el
            óxido nítrico que tu cuerpo dejó de producir. Y funciona por DOS
            caminos:
          </p>

          <div className="mb-10 space-y-6" data-id="element-71">
            <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 p-6" data-id="element-72">
              <div className="absolute right-0 top-0 -mr-4 -mt-4 h-24 w-24 rounded-full bg-[#d4a5a5]/10" data-id="element-73"></div>
              <h3 className="mb-2 font-serif text-xl font-bold text-[#d4a5a5]" data-id="element-74">
                CAMINO 1
              </h3>
              <p data-id="element-75">
                Un extracto concentrado de betabel que le da a tu sangre los
                nitratos que necesita por una RUTA ALTERNA — sin depender del
                sistema dañado de tu cuerpo. Es como abrir una carretera nueva
                cuando la principal está bloqueada.
              </p>
            </div>

            <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-gray-50 to-gray-100 p-6" data-id="element-76">
              <div className="absolute right-0 top-0 -mr-4 -mt-4 h-24 w-24 rounded-full bg-[#d4a5a5]/10" data-id="element-77"></div>
              <h3 className="mb-2 font-serif text-xl font-bold text-[#d4a5a5]" data-id="element-78">
                CAMINO 2
              </h3>
              <p data-id="element-79">
                Un extracto de semilla de uva que REPARA el revestimiento
                interno de tus arterias — para que eventualmente vuelvan a
                producir óxido nítrico por sí solas.
              </p>
            </div>
          </div>

          <p className="mb-10" data-id="element-80">
            Uno te da alivio rápido. El otro repara el daño a largo plazo. Y lo
            mejor: no son pastillas enormes difíciles de tragar, ni jugos de
            betabel con sabor a tierra. Es algo que realmente disfrutas tomar
            cada mañana.
          </p>

          {/* Testimonials */}
          <div className="mb-12" data-id="element-81">
            <h3 className="mb-4 text-center font-serif text-2xl font-bold" data-id="element-82">
              Miles de mujeres mexicanas ya están experimentando la diferencia:
            </h3>

            <p className="mb-8 text-center font-medium text-gray-600" data-id="element-83">
              Esto es lo que están diciendo:
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-84">
              {[{
              text: 'Ya había probado de todo. Voy en mi tercer frasco y ya no ando arrastrando los pies todo el día. Hasta mi esposo notó el cambio.',
              author: 'Alicia M., 58 años, CDMX',
              image: 'https://cdn.magicpatterns.com/uploads/goxcU61367NjhqHkD5LFCe/TESTS_-_Arcads_image_asset_(13).png'
            }, {
              text: 'Pensé que el cansancio era normal a mi edad. Llevo 3 semanas y mi esposo dice que ando más alegre. ¡Hasta me dan ganas de arreglarme!',
              author: 'María Elena, 46 años, Guadalajara',
              image: 'https://cdn.magicpatterns.com/uploads/tnmLLb66JXLw92Qf2Qnror/TESTS_-_Arcads_image_asset_(16).png'
            }, {
              text: 'Mis hijas me decían que ya no salía ni al mandado. Ahora hasta las acompaño al tianguis. Me siento viva otra vez.',
              author: 'Laura C., 63 años, Querétaro',
              image: 'https://cdn.magicpatterns.com/uploads/5g8a15fJMfrmtXTS2sxRgJ/Captura_de_pantalla_2026-01-24_a_las_12.21.56.png'
            }].map((t, i) => <div key={i} className="rounded-xl border-2 border-gray-200 p-6 shadow-sm" data-id="element-85">
                  {t.image ? <div className="space-y-4" data-id="element-86">
                      <img src={t.image} alt={t.author} className="w-full rounded-lg object-cover shadow-md" data-id="element-87" />
                      <p className="italic text-gray-700 text-base leading-relaxed" data-id="element-88">
                        {t.text}
                      </p>
                      <div className="flex items-center gap-2 pt-2" data-id="element-89">
                        <Check className="h-5 w-5 text-green-600" data-id="element-90" />
                        <p className="text-sm font-bold text-gray-900" data-id="element-91">
                          {t.author}
                        </p>
                      </div>
                    </div> : <div className="space-y-4" data-id="element-92">
                      <p className="italic text-gray-700 text-base leading-relaxed" data-id="element-93">
                        {t.text}
                      </p>
                      <div className="flex items-center gap-2 pt-2" data-id="element-94">
                        <Check className="h-5 w-5 text-green-600" data-id="element-95" />
                        <p className="text-sm font-bold text-gray-900" data-id="element-96">
                          {t.author}
                        </p>
                      </div>
                    </div>}
                </div>)}
            </div>

            <div className="mt-8 rounded-lg bg-[#d4a5a5]/10 p-4 text-center text-sm font-medium text-[#d4a5a5]" data-id="element-97">
              El 93% de las usuarias reportan más energía y claridad mental en
              las primeras 2 semanas.
            </div>
          </div>

          {/* Product Section */}
          <div className="mb-12 rounded-2xl border-2 border-[#d4a5a5]/30 bg-gradient-to-br from-white to-gray-50 p-8 shadow-xl" data-id="element-98">
            <h2 className="mb-6 text-center font-serif text-3xl font-bold text-gray-900" data-id="element-99">
              Angelitas Gummy: La solución que más de 4,700 mexicanas ya están
              usando
            </h2>

            <div className="mb-8 flex justify-center" data-id="element-100">
              <img src="https://cdn.magicpatterns.com/uploads/gNWdCJ4BWTYRTvc4ABrUu7/Captura_de_pantalla_2026-01-24_a_las_12.44.04.png" alt="Angelitas Gummy Product" className="w-full max-w-md" data-id="element-101" />
            </div>

            <p className="mb-8 text-center text-lg" data-id="element-102">
              Se llama{' '}
              <strong className="text-[#d4a5a5]" data-id="element-103">Angelitas Gummy</strong> — una
              gomita de betabel y semilla de uva que restaura el óxido nítrico
              que tu cuerpo dejó de producir.
            </p>

            <h3 className="mb-6 font-serif text-xl font-bold text-gray-900" data-id="element-104">
              Lo que la hace diferente:
            </h3>

            <ul className="mb-8 space-y-4" data-id="element-105">
              {[{
              text: '500mg de extracto de betabel',
              desc: 'la dosis clínica comprobada para resultados reales'
            }, {
              text: '150mg de semilla de uva Enovita®',
              desc: 'repara tus arterias desde adentro'
            }, {
              text: 'Sabor fresa, sin azúcar',
              desc: 'nada de sabor a tierra ni pastillas gigantes'
            }, {
              text: 'Solo 2 gomitas al día',
              desc: 'un ritual de 30 segundos cada mañana'
            }, {
              text: '4.9 estrellas de 4,718 reseñas verificadas',
              desc: ''
            }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-106">
                  <Check className="mt-1 h-5 w-5 flex-shrink-0 text-green-600" data-id="element-107" />
                  <span data-id="element-108">
                    <strong className="text-gray-900" data-id="element-109">{item.text}</strong>
                    {item.desc && <span className="text-gray-600" data-id="element-110"> — {item.desc}</span>}
                  </span>
                </li>)}
            </ul>

            <div className="mb-8 flex items-center justify-center gap-1 text-yellow-500" data-id="element-111">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-6 w-6 fill-current" data-id="element-112" />)}
              <span className="ml-2 text-sm font-bold text-gray-700" data-id="element-113">
                4.9/5.0 (4,718 reseñas)
              </span>
            </div>

            <div className="mb-8 flex items-start gap-3 rounded-lg bg-yellow-50 p-4 text-sm text-yellow-800" data-id="element-114">
              <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-yellow-600" data-id="element-115" />
              <p data-id="element-116">
                <strong data-id="element-117">IMPORTANTE:</strong> Debido a la alta demanda, el
                inventario es limitado. Angelitas es actualmente el suplemento
                más vendido de México en 2025 y frecuentemente se agota.
              </p>
            </div>

            <div className="mb-8 text-center" data-id="element-118">
              <p className="mb-2 font-medium text-gray-900" data-id="element-119">
                Si estás cansada de estar cansada...
              </p>
              <p className="mb-2 font-medium text-gray-900" data-id="element-120">
                Si ya no quieres ser la mamá que "siempre está agotada"...
              </p>
              <p className="mb-6 font-medium text-gray-900" data-id="element-121">
                Si quieres volver a ser el pilar FUERTE que tu familia
                necesita...
              </p>
              <p className="font-bold text-[#d4a5a5]" data-id="element-122">
                Este es el momento de actuar.
              </p>
            </div>

            <a href="https://angelitasgummy.com/products/angelitas" target="_blank" rel="noopener noreferrer" className="group relative block w-full overflow-hidden rounded-xl bg-[#d4a5a5] px-8 py-5 text-center font-bold text-white shadow-lg transition-all hover:bg-[#c08b8b] hover:shadow-xl hover:-translate-y-0.5" data-id="element-123">
              <div className="relative z-10 flex items-center justify-center gap-3" data-id="element-124">
                <ChevronRight className="h-6 w-6 transition-transform group-hover:translate-x-1" data-id="element-125" />
                <span className="text-lg sm:text-xl" data-id="element-126">
                  CLICK PARA VER DISPONIBILIDAD
                </span>
              </div>
            </a>

            <div className="mt-6 rounded-lg bg-green-50 p-4 text-center" data-id="element-127">
              <p className="font-bold text-green-800" data-id="element-128">Garantía de 30 días:</p>
              <p className="text-sm text-green-700" data-id="element-129">
                Si no sientes más energía y claridad mental en las primeras
                semanas, te devuelven tu dinero. Sin preguntas.
              </p>
            </div>
          </div>
        </article>
      </main>

      {/* Footer */}
      <footer className="mt-12 border-t border-gray-100 bg-gray-50 py-12 text-center text-sm text-gray-500" data-id="element-130">
        <div className="mx-auto max-w-3xl px-4" data-id="element-131">
          <p className="mb-4 font-bold text-gray-400" data-id="element-132">AVISO LEGAL:</p>
          <p className="mb-6 text-xs leading-relaxed" data-id="element-133">
            Este es un publirreportaje y no un artículo de noticias. Los
            resultados pueden variar de persona a persona. Este producto no está
            destinado a diagnosticar, tratar, curar o prevenir ninguna
            enfermedad. Consulta a tu médico antes de comenzar cualquier
            suplemento. Las declaraciones no han sido evaluadas por COFEPRIS.
          </p>
          <div className="mb-6 flex flex-wrap justify-center gap-4 sm:gap-8" data-id="element-134">
            <a href="#" className="hover:text-gray-900 hover:underline" data-id="element-135">
              Términos de Uso
            </a>
            <a href="#" className="hover:text-gray-900 hover:underline" data-id="element-136">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-gray-900 hover:underline" data-id="element-137">
              Contacto
            </a>
          </div>
          <p data-id="element-138">©2025 Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>;
}